import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';
import Env from '../../../env/env';

interface PerformanceData {
  liquidity: string[];
  pricing: string[];
}

interface ParsedPerformanceData {
  liquidity: {
    line: string;
    color: string;
  }[];
  pricing: {
    line: string;
    color: string;
  }[];
}

enum ConsoleColor {
  WHITE = '#c7c7c7',
  RED = '#c91b00',
  BLUE = '#268bd2',
  GREEN = '#00c200',
  MAGENTA = '#c930c7',
  YELLOW = '#c7c400',
  CYAN = '#00c5c7',
  ORANGE = '#b58900'
}

@Component({
  selector: 'app-performance',
  templateUrl: './performance.component.html',
  styleUrls: ['./performance.component.css']
})
export class PerformanceComponent implements OnInit {
  performance: ParsedPerformanceData;

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.http.get<PerformanceData>(Env.apiUrl + '/vma/performance').subscribe((data) => {
      this.performance = {
        liquidity: data.liquidity.map(this.parsePerformance),
        pricing: data.pricing.map(this.parsePerformance)
      };
    });
  }

  parsePerformance(line: string) {
    let color = ConsoleColor.WHITE;

    if (line.startsWith('****')) {
      color = ConsoleColor.BLUE;
    }
    if (line.match(/Medium (: )?[0-9]+/) || line.match(/Segment [0-9]+(\.[0-9]+)?/) || line === 'GLOBAL') {
      color = ConsoleColor.ORANGE;
      line = line.padStart(25 + (line.length / 2));
    }

    if (line.startsWith('----')) {
      color = ConsoleColor.GREEN;
    }
    if (line.startsWith('Feature importance for medium')) {
      color = ConsoleColor.YELLOW;
      line = line.padStart(25 + (line.length / 2));

    }

    return { color, line };
  }

  getColor(color: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle('color:' + color);
  }
}
